import React, {memo} from 'react';
import styles from './Loader.module.scss';

type LoaderProps = {
    color?: string;
    className?: string;
};

const Loader = memo(function Loader({color, className}: LoaderProps) {
    const dotStyle = color ? {background: color} : undefined;
    return (
        <div className={[styles.ldsEllipsis, className].join(' ')}>
            <div style={dotStyle} />
            <div style={dotStyle} />
            <div style={dotStyle} />
            <div style={dotStyle} />
        </div>
    );
});

export default Loader;
